<template>
  <div>
    <font-awesome-icon icon="sort" v-if="sortProperty !== column"/>
    <font-awesome-icon icon="sort-up" class="sort-up-down" v-if="sortProperty == column && sortAscending"/>
    <font-awesome-icon icon="sort-down" class="sort-up-down" v-if="sortProperty == column && !sortAscending"/>
  </div>
</template >

<script>
export default {
  props: ['column', 'sortProperty', 'sortAscending']
}
</script>

<style lang='scss' scoped>
  div {
    display: inline-block;
    margin-left: 3px;
  }
</style>
